import { LitElement, html, css, nothing } from "lit";
import { property, customElement } from "lit/decorators.js";
import { FeedbackTypes } from "./feedback-types";
import { SvgIcons } from "../../voyage-svg-icons/src/voyage-svg-icons";
import { VoyFleetNotificationModel } from "../../../src/models/voy-fleet-notification-model";
import { AuthService } from "../../../src/services/auth-service";
import "@maersk-global/mds-components-core/mc-modal";

const feedbackArray = [
  {
    title: FeedbackTypes.VerySad,
    icon: SvgIcons.faceVerySad,
    className: "very-sad",
  },
  {
    title: FeedbackTypes.Sad,
    icon: SvgIcons.faceSad,
    className: "sad",
  },
  {
    title: FeedbackTypes.Neutral,
    icon: SvgIcons.neutral,
    className: "neutral",
  },
  {
    title: FeedbackTypes.Happy,
    icon: SvgIcons.faceHappy,
    className: "happy",
  },
  {
    title: FeedbackTypes.VeryHappy,
    icon: SvgIcons.faceVeryHappy,
    className: "very-happy",
  },
];

@customElement("voy-feature-feedback-popup")
export class VoyVFeedbackPopup extends LitElement {
  @property({ type: Boolean, reflect: true }) shown: boolean = true;
  @property({ attribute: false }) selected: string = "";
  @property({ attribute: false }) private _comment: string = "";
  @property({ attribute: false }) private submitted: boolean = false;
  @property({ type: Boolean, reflect: true }) showCloseIcon: boolean = false;

  static get styles() {
    return [
      css`
        :host {
          font-family: MaerskText;
        }
        .comment {
          font-family: "MaerskText";
          width: 412px;
          height: 50px;
          border: 1px solid #c4c4cd;
          line-height: 20px;
          resize: vertical;
          border-radius: 6px;
        }

        .content {
          margin-left: 20px;
        }
        .max-width-container h2 {
          margin-top: 0px;
        }
        .name {
          color: var(--neutrals-grey-02, grey);
          font-size: 16px;
          font-family: MaerskText;
          line-height: 20px;
          font-weight: 400;
          margin-top: 20px;
          margin-bottom: 10px;
        }
        .desc {
          color: var(--neutrals-grey-02, grey);
          font-size: 14px;
          font-family: MaerskText;
          line-height: 20px;
          margin-top: -10px;
        }
        .desc span {
          text-decoration: underline;
          cursor: pointer;
        }

        .title {
          margin-top: 0px;
          font-family: MaerskText;
        }

        .comment-input {
          width: 100%;
          position: realtive;
        }
        .max-width-container {
          width: 100%;
        }
        .center {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }

        .comment-input > textarea {
          white-space: normal;
          padding-left: 10px;
          font-family: MaerskText;
        }
        .footer {
          text-align: end;
          padding: 16px 24px;
          margin: -24px;
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          padding: 16px 24px;
          gap: 12px;
          height: 64px;
          background: #f7f7f7;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        .footer-button {
          background-color: #ffffff;
        }
        .feedback-icon {
          text-align: center;
        }
        .feedback-icon span {
          cursor: pointer;
        }
        .very-sad[selected] {
          fill: red;
        }
        .sad[selected] {
          fill: #ee7f09;
        }
        .neutral[selected] {
          fill: #e4dc18;
        }
        .happy[selected] {
          fill: #78e3be;
        }
        .very-happy[selected] {
          fill: #079c69;
        }
        .error-message {
          color: red;
        }
        .rating {
          text-align: center;
        }
      `,
    ];
  }

  render() {
    return html`${this._renderFeedbacktModal()}`;
  }
  private _renderFeedbacktModal() {
    return html`<mc-modal
      heading="What is your overall satisfaction with our service?"
      ?open=${this.shown}
      dimension="small"
      width="505px"
      height="346px"
      backdropcloseactiondisabled
      escapecloseactiondisabled
      entercloseactiondisabled
      ?hiddenclose=${!this.showCloseIcon}
      @closing=${() => {
        this.dispatchEvent(new Event("close"));
        this.submitted = false;
        this.selected = "";
        this._comment = "";
        this.shown = false;
        this.showCloseIcon = false;
      }}
    >
      ${this._renderModalContent()}
      <div class="footer">
        <mc-button
          focusstartanchor
          appearance="primary"
          variant="filled"
          @click=${this._onSubmit}
          >Submit</mc-button
        >
      </div>
    </mc-modal> `;
  }

  private _renderModalContent() {
    return html`
                <div class="feedback-icon">
                    ${feedbackArray.map((val) => {
                      return html`
                        <span
                          class=${val.className}
                          ?selected=${this.selected == val.title}
                          @click=${() => (this.selected = val.title)}
                          >${val.icon}
                        </span>
                      `;
                    })}
                     ${
                       this.selected == "" && this.submitted
                         ? html` <span class="error-message">*</span> `
                         : nothing
                     }                
                </div>
                ${this.selected ? this._showRating() : ""}
                    <div class="comment-input">
                        <div class="name">Tell us more</div>
                            <textarea class="comment" placeholder="Anything else to add"   @input = ${(evt: {
                              target: { value: string };
                            }) =>
                              (this._comment =
                                evt.target.value.trim())}></textarea> 
                         </div>
                    </div>
        `;
  }

  private _onSubmit() {
    this.submitted = true;
    if (this.selected) {
      VoyFleetNotificationModel?.postFeedback(
        this._payloadForSubmitReason()
      )
      this.dispatchEvent(new Event("close"));
      this.submitted = false;
      this.selected = "";
      this._comment = "";
      this.shown = false;
      this.showCloseIcon = false;
    }
  }

  private _payloadForSubmitReason() {
    let ratingVal: number = 0;
    switch (this.selected) {
      case FeedbackTypes.VerySad:
        ratingVal = 1;
        break;
      case FeedbackTypes.Sad:
        ratingVal = 2;
        break;
      case FeedbackTypes.Neutral:
        ratingVal = 3;
        break;
      case FeedbackTypes.Happy:
        ratingVal = 4;
        break;
      case FeedbackTypes.VeryHappy:
        ratingVal = 5;
        break;
    }
    const username: string = AuthService.getUserDetails();
    return {
      category: "Voyage",
      type: "FleetNPS",
      data: JSON.stringify({
        rating: ratingVal,
        comments: this._comment,
        username: username,
        feedbackGivenMonth: JSON.stringify(new Date().getMonth()),
      }),
      imoNo: 1000000, // using a dummy imo as  imo is mandatory for the api
    };
  }

  private _showRating() {
    const ratingText = {
      [FeedbackTypes.VerySad]: "Very sad",
      [FeedbackTypes.Sad]: "Sad",
      [FeedbackTypes.Neutral]: "Neutral",
      [FeedbackTypes.Happy]: "Happy",
      [FeedbackTypes.VeryHappy]: "Very happy",
    }[this.selected as FeedbackTypes];

    return html`<div class="rating">${ratingText}</div>`;
  }
}
